<template>
    <div :class="`statement-container type-${type}`">
        <span class="state-title no-border" @click="showDialog" v-if="feedbackType == 'B'"><i class="icon icon-ic_statement"></i>声明</span>
        <span class="state-title" @click="showDialog" v-if="feedbackType == 'A'">平台声明</span>
        <span class="judge-entry no-border" @click="showFeedback" v-if="feedbackType == 'B'" data-spm-data="f"><i class="icon icon-ic_feedback"></i>反馈</span>
        <div class="state-content" v-if="isShowDialog">
            声明：该文观点仅代表作者本人，搜狐号系信息发布平台，搜狐仅提供信息存储空间服务。
        </div>
    </div>
</template>

<script>
export default {
    props: {
        type: {
            type: Number,
            default: 1
        },
        sgrade: {
            type: Number,
            default: 0
        }
    },
    data() {
        return {
            isShowDialog: false,
        }
    },
    computed: {
        feedbackQuestion() {
            return JSON.parse(window.cfgs && window.cfgs.feedbackQuestion || '[]')
        },
        feedbackType() {
            if(this.type == 3 && this.sgrade == 0 && this.feedbackQuestion && this.feedbackQuestion.length) {
                return 'B'
            }else {
                return 'A'
            }
        }
    },
    methods: {
        showDialog() {
            this.isShowDialog = true;
            if (window.sohuSpm && typeof window.sohuSpm.sendAction === 'function') {
                window.sohuSpm.sendAction({
                    acode: '8435'
                });
            }
        },
        showFeedback() {
            $('#articleJudge').removeClass('hidden').toggleClass('fadeout')
            this.$nextTick(() => {
                if (window.sohuSpm && typeof window.sohuSpm.reScan === 'function') {
                    window.sohuSpm.reScan()
                }
            })
        }
    },
    mounted() {
        window.addEventListener('scroll', ()=> {
            this.isShowDialog = false;
        })
        $('body').on('click', (e)=> {
            if(!(e.target.getAttribute('class')) || e.target.getAttribute('class').indexOf('state-title') < 0) {
                this.isShowDialog = false;
            }
        })
    }

}
</script>

<style lang="less" scoped>
    .statement-container {
        position: relative;
        display: flex;
        .state-title, .judge-entry {
            display: flex;
            justify-content: center;
            align-items: center;
            height: 56px;
            border-radius: 24px;
            // font-size: 22px!important;/*px*/
            color: #656565;
            font-size: 24px !important;/*px*/
            letter-spacing: 0.44px;
            line-height: 24px; /*px*/
        }
        .judge-entry {
            margin-left: 16px;
            border: 1px solid #f5f5f5;/*no*/
        }
        .no-border {
            border: none;
        }
        .state-content {
            z-index: 10;
            position: absolute;
            right: 0px;
            top: 70px;
            width: 347px;
            padding: 14px 10px 14px 20px;
            background-size: cover;
            box-shadow:0px 3px 12px 0px rgba(51,51,51,0.1);
            border-radius:4px;
            background:rgba(255,255,255,1);
            line-height: 32px;
            color: #666666;
            font-size: 22px;/*px*/
            &::before {
                content:'';
                width: 0;
                height: 0;
                border: 5px solid transparent;/*no*/
                position: absolute;
                top: -10px;/*no*/
                right: 30px;
                border-bottom-color: #ffffff;
            }
        }
        i {
            font-size: 24px;/*px*/
            margin-right: 8px;
        }
        &.type-3 {
            i {
                font-size: 32px; /*px*/
            }
            .state-title, .judge-entry {
                padding: 0;
            }
            .state-content {
                &:before {
                    right: 140px;
                }
            }
        }
    }
</style>
